import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createBlock(_component_InputNumber, {
    modelValue: _ctx.saveId,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.saveId) = $event)),
    showButtons: "",
    buttonLayout: "horizontal",
    decrementButtonClass: "p-button-danger",
    incrementButtonClass: "p-button-success",
    incrementButtonIcon: "pi pi-plus",
    decrementButtonIcon: "pi pi-minus",
    mode: "decimal",
    min: 1,
    max: 100,
    inputClass: "w-4rem text-center"
  }, null, 8, ["modelValue"]))
}